import { Card, CardBody, Col, Container, Row, Table, } from "reactstrap";
import { Image, Badges, Btn } from "../../../AbstractElements";
import { generateRandomNumber, itemHasPermission, URL_API } from "../../../utils/helper/helpers";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { formatDate, formatPhoneNumber } from "../../../utils/helper/helpers";

import { Link, useParams } from "react-router-dom";
import { dynamicImage } from "../../../Service";
import { downloadPreuve } from "../apiBon";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import { EditerBonDiamond } from "../../../utils/helper/modal";

// Types
type Verse = { [key: string]: any }

const ShowAutresBons = () => {

    const [bons, setBons] = useState<Verse | null>(null);

    const [refresh, setRefresh] = useState(false);
    const params = useParams();
    const pdfRef = useRef<HTMLDivElement>(null);
    const [show, setShow] = useState(true);

    // Modal gestion
    const [showModal, setShowModal] = useState<boolean>(false);
    const [item, setItem] = useState<any>({})
    const openModal = () => {
        setItem({
                id: bons?.id,
                immatriculation: bons?.immatriculation,
                destination: bons?.destination,
                nom_chauffeur: bons?.nom_chauffeur,
                num_permis: bons?.num_permis,
                telephone: bons?.telephone,
            });
        setShowModal(true);
    }


    const handlePrint = useReactToPrint({
        content: () => pdfRef.current,
    });

    const onPrint = () => {
        setShow(false); // Masquer le contenu
        setTimeout(() => {
            handlePrint(); // Appeler la fonction d'impression
            setShow(true); // Réafficher après un délai
        }, 100); // Assurez-vous que le DOM a le temps de se mettre à jour
    };

    // const handlePrint = 
    const generatePDF = () => {
        setShow(false)
        const element = pdfRef.current;
        const name_document = generateRandomNumber(100000, 999999);
        if (element) {
            html2pdf()
                .from(element)
                .save(`Bon_De_Commande_${name_document}.pdf`)
                .then(() => setShow(true))
                .catch(() => setShow(true));
        }
    };

    // Fetch data from API
    const fetchBons = useCallback(async () => {
        try {
            const Token = JSON.parse(localStorage.getItem("login")!);
            const response = await axios.get(`${URL_API}/bon/get/${params.id}`, {
                headers: { Authorization: `Bearer ${Token}` }
            });
            if (response.data.success) {
                setBons(response.data.bon);
            }
        } catch (error: any) {
            const message = error.response?.data?.message || "Erreur inconnue";
            toast.error(message);
        }
    }, []);

    // Initial data fetch
    useEffect(() => {
        fetchBons();
    }, [refresh, fetchBons]);

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Bons Details" parent="Bons" />
            <Container fluid>
                <Card>
                    <CardBody>
                        <div ref={pdfRef}>
                            <div className="text-center my-auto py-5">
                                <h1 className="text-uppercase fw-bold">{bons?.four_name}</h1>
                                <p className="f-17">{bons?.four_address}</p>
                                <p className="f-18">{formatPhoneNumber(bons?.four_phone)}</p>
                            </div>
                            {
                                bons?.four_type === 'diamond' || bons?.four_type === 'diamond_sougueta' ? (
                                    <Row className="mx-3 my-2">
                                        <Col sm={6} className="text-start text-uppercase">
                                            <p className="f-17"><span className="fw-bold">Nom du client </span> : {bons?.ets_name}</p>
                                            <p className="f-17"><span className="fw-bold" >Code </span>: {bons?.ets_code}</p>
                                            <p className="f-17"><span className="fw-bold" >Tel </span>: {formatPhoneNumber(bons?.ets_phone)}</p>
                                            <p className="f-17"><span className="fw-bold" >Adresse </span>: {bons?.ets_adresse}</p>
                                        </Col>
                                        <Col sm={6} className="text-end">
                                            <p className="f-17">Loading Permit No: <span className="text-uppercase">{bons?.num}</span></p>
                                            <p className="f-17">Loading Permit Date: <span className="text-uppercase"> {formatDate(bons?.date_bons)}</span></p>
                                        </Col>
                                    </Row>
                                ) : (
                                    <Row className="mx-3 my-2">
                                        <Col sm={6}>
                                            <p className="f-17"><span className="fw-bold">Nom </span> : {bons?.ets_name}</p>
                                            <p className="f-17"><span className="fw-bold">Code </span>: {bons?.ets_code}</p>
                                            <p className="f-17"><span className="fw-bold">Tel </span>: {formatPhoneNumber(bons?.ets_phone)}</p>
                                            <p className="f-17"><span className="fw-bold">Adresse </span>: {bons?.ets_adresse}</p>
                                        </Col>
                                        <Col sm={6} className="text-center">
                                            <h2 className="fw-bold"> BON D'EVENEMENT</h2>
                                            <h1 className="text-danger my-3 fw-bold text-uppercase" style={{ fontFamily: 'Courier' }}>{bons?.num}</h1>
                                        </Col>

                                    </Row>
                                )
                            }

                            <div className="mx-3 mt-5">
                                <Table bordered responsive className="text-center">
                                    <thead>
                                        <tr className="f-17">
                                            <th scope="col">DATE</th>
                                            <th scope="col">TYPE DE MATERIEL</th>
                                            <th scope="col">QUANTITE TONNE</th>
                                            <th scope="col">QUANTITE SAC</th>
                                            {/* <th scope="col">STATUS</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="f-17 text-capitalize">
                                            <td>{formatDate(bons?.date_bons)}</td>
                                            <td>{bons?.versement_materiel ?? bons?.materiel}</td>
                                            <td>{bons?.quantite_tonne}</td>
                                            <td>{(bons?.quantite_tonne ?? 0) * 20}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <div className="my-5">
                                    <p className="f-17 my-1"><span className="fw-bold" style={{ paddingRight: "10px" }}>NUMERO DU CAMION </span> : {bons?.immatriculation}</p>
                                    <p className="f-17 my-1"><span className="fw-bold" style={{ paddingRight: "6px" }}>NUMERO DU REMORK </span> : {bons?.immatriculation}</p>
                                    <p className="f-17 my-1"><span className="fw-bold" style={{ paddingRight: "73px" }}>DESTINATION </span> : {bons?.destination}</p>
                                    <p className="f-17 my-1"><span className="fw-bold" style={{ paddingRight: "10px" }}>NOM DU CHAUFFEUR </span> : {bons?.nom_chauffeur}</p>
                                    <p className="f-17 my-1"><span className="fw-bold" style={{ paddingRight: "8px" }}>NUMEROS DU PERMIS </span> : {bons?.num_permis}</p>
                                    <p className="f-17 my-1"><span className="fw-bold" style={{ paddingRight: "85px" }}>TELEPHONE </span> : {formatPhoneNumber(bons?.telephone)}</p>
                                </div>
                                <div className="text-end my-4" >

                                    <p className="f-17"> Enrégistré par : <span className="fw-bold">{bons?.users_name + " " + bons?.users_firstname}</span></p>
                                    {
                                        bons?.users_signature
                                            ? (<Image src={bons.users_signature} alt="User signature" />)
                                            : (null)
                                    }
                                    <p className="f-17"> Téléphone : <span className="fw-bold">{formatPhoneNumber(bons?.users_phone)}</span></p>
                                </div>
                            </div>
                        </div>
                        <div className="text-end">
                            {
                                (itemHasPermission('super admin') || itemHasPermission('gest. bons ecriture')) && (
                                    <Btn color="light-success" className="btn btn-sm !w-full fw-bold text-dark" onClick={openModal}>
                                        Modifier Le Bon De Commande
                                    </Btn>
                                )
                            }
                            {/* <Btn color="light-info" className="btn btn-sm mx-2 fw-bold text-dark" onClick={() => downloadPreuve(bons?.id, bons?.preuve)}>
                                <i className="fa fa-download"></i> Imprimmer
                            </Btn> */}
                            <Btn color="light-info" onClick={onPrint} className="btn btn-xs m-1 p-1 px-3">
                                <i className="fa fa-print"></i> Imprimer
                            </Btn>
                            {
                                bons?.preuve ? (
                                    <>
                                        <Btn color="light-dark" className="btn btn-sm m-1 fw-bold text-dark for-light" onClick={() => downloadPreuve(bons?.id, bons?.preuve)}>
                                            <i className="fa fa-download"></i> Télécharger
                                        </Btn>
                                        <Btn color="light-light" className="btn btn-sm m-1 fw-bold text-dark for-dark" onClick={() => downloadPreuve(bons?.id, bons?.preuve)}>
                                            <i className="fa fa-download"></i> Télécharger
                                        </Btn>
                                    </>
                                ) : (
                                    <>
                                        <Btn color="light-dark" className="btn btn-sm m-1 fw-bold text-dark for-light" onClick={generatePDF}>
                                            <i className="fa fa-download"></i> Télécharger
                                        </Btn>
                                        <Btn color="light-light" className="btn btn-sm m-1 fw-bold text-dark for-dark" onClick={generatePDF}>
                                            <i className="fa fa-download"></i> Télécharger
                                        </Btn>
                                    </>
                                )
                            }

                            <Link to="/autres-bon-de-commande" className="btn btn-sm m-1 btn-light-danger">
                                <i className="fa fa-sign-out"></i> Quitter
                            </Link>
                        </div>
                    </CardBody>
                </Card>
                <EditerBonDiamond 
                    isOpen={showModal} 
                    item={item} 
                    toggle={() => setShowModal(prev => !prev)}
                    num_bons={bons?.num} 
                    onSuccess={() => setRefresh(prev => !prev)}
                    onCancel={() => {toast.info("Modification annulée.");}}
                />
            </Container>
        </div >

    )
}

export default ShowAutresBons;